<h1 mat-dialog-title>{{ data.title }}</h1>

<div mat-dialog-content>
  {{ data.message }}

  <div *ngIf="data.highlight" class="font-bold break-all mt-1">{{ data.highlight }}</div>

  <mat-form-field *ngIf="data.askReason" class="mt-3 w-full" appearance="outline">
    <mat-label>{{ data.reasonLabel || 'Reason' }}</mat-label>
    <textarea
      matInput
      [(ngModel)]="reason"
      [placeholder]="data.reasonPlaceholder || 'Enter reason'"
      rows="3"
    ></textarea>
  </mat-form-field>
</div>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ data.cancelText || 'Cancel' }}</button>
  <button
    mat-button
    cdkFocusInitial
    [color]="data.confirmColor || 'warn'"
    [disabled]="isConfirmDisabled"
    (click)="confirm()"
  >
    {{ data.confirmText || 'Confirm' }}
  </button>
</mat-dialog-actions>
